import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { Option, createCommand } from '@commander-js/extra-typings';
import { createI18nT } from '../i18n.js';

export const addPermissionCommand = (services: CommandServices) => {
  const t = createI18nT();

  return createCommand('add-permission')
    .description('adding a permission to the app')
    .addOption(
      new Option('-p, --permission-id <id>', t('the permission id to add'))
    )
    .action(async (options, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { AddPermissionCommand } = await import(
        '../components/AddPermissionCommand/index.js'
      );

      const { permissionId = '' } = options;

      await renderCommand(
        command,
        services,
        <AddPermissionCommand permissionId={permissionId} />
      );
    });
};
